export default __webpack_public_path__ + "static/media/pink_shadown_circle.e9578328.svg";